import { observable, action } from 'mobx'

// HistoryPostStore 는 화면이 보는 목록만 들고 있다. 중복 제거·상한 같은 규칙은 history.js 가
// 갖는다 (다시보기의 분업과 같다).
// replace 는 저장이 성공한 뒤에만 불린다. 그래서 이 배열은 언제나 localStorage 와 같은
// 내용이고, 저장이 실패해도 되돌릴 것이 없다.
export class HistoryPostStore {
  @observable posts = []

  @action.bound
  replace(posts) {
    this.posts = posts
  }
}
